import * as signalR from '@microsoft/signalr';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy,
  OnInit, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation
} from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Message } from '../../interfaces/message';
import { NotificationResponse } from '../../interfaces/notification-response';

@Component({
  selector: 'mes-box-messages',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    NgTemplateOutlet
  ],
  templateUrl: './box-messages.html',
  styleUrl: './box-messages.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BoxMessages implements OnInit, OnDestroy {
  @ViewChild('notificationsOrigin') private _notificationsOrigin: MatButton;
  @ViewChild('notificationsPanel') private _notificationsPanel: TemplateRef<any>;

  messages: Message[] = [
    // {
    //   username: "objMessage.username link",
    //   message: "objMessage.message",
    //   recipient: "bjMessage.recipient",
    //   viewed: false,
    //   link: "asd",
    // },
    // {
    //   username: "objMessage.username link empty",
    //   message: "objMessage.message",
    //   recipient: "bjMessage.recipient",
    //   viewed: false,
    //   link: "",
    // },
    // {
    //   username: "objMessage.username link null",
    //   message: "objMessage.message",
    //   recipient: "bjMessage.recipient",
    //   viewed: false,
    // }
  ];

  unreadCount: number = 0;
  private _overlayRef: OverlayRef;

  private hubConnection: signalR.HubConnection;
  private apiUrl = 'https://pre-q8oil.mykrake.com';
  // TEST: for send message go to: https://pre-q8oil.mykrake.com/pagina-chat

  constructor(
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef
  ) {
    this.setConnection();
  }

  ngOnInit(): void {
    //call iniziale per notifiche da mostrare
  }

  ngOnDestroy(): void {
    this.hubConnection.stop();

    // Dispose the overlay
    if (this._overlayRef) {
      this._overlayRef.dispose();
    }
  }

  private setConnection() {

    let user = 'demouser';

    this.hubConnection = new signalR.HubConnectionBuilder()
      ////TODO: si dovra aggiungere l'utente. Probabile negli header (IHttpConnectionOptions)
      .withUrl(`${this.apiUrl}/chathub?userId=${user}`,{
        // headers: {
        //   'Custom-Header': 'ValoreCustom'
        // },
        withCredentials: false
      } as signalR.IHttpConnectionOptions)
      .build();

    // Aggiungo questi eventi prima di fare lo "start" perche lato WS appena mi connetto mi mandano quelli non letti.
    this.hubConnection.on('ReceiveMessage', (objMessage: Message) => {
      this.manageMessage(objMessage, false);
    });

    this.hubConnection.on('ReceivePrivateMessage', (objMessage: Message) => {
      this.manageMessage(objMessage, true);
    });

    this.hubConnection.on('ReceiveUnreadMessages', (messagesList: []) => {
      for(let objMessage of messagesList) {
        this.manageMessage(objMessage, false);
      }
    });

    this.hubConnection.on('MessageRead', (notificationResponse: NotificationResponse) => {
      if(!notificationResponse.success) {
        // capire se mostrare errore
      }
    });

    // Mi conntetto
    //TODO: riattivare quando fixato
    // this.hubConnection.start()
    //   .then(() => console.log('SignalR connection started'))
    //   .catch(err => console.log('Error while starting connection: ' + err));


    // QUANDO LI LEGGERO USARE:
    // this.hubConnection.invoke('ReadMessage', oggetto.id);
  }

  private manageMessage(objMessage: Message, isPrivate: boolean) {
    // console.log("Messaggio arrivato!")
    this.unreadCount += 1;

    this.messages.push({
      id: objMessage.id,
      issuer: objMessage.issuer,
      message: objMessage.message,
      recipient: objMessage.recipient,
      createdOn: objMessage.createdOn,
      readOn: objMessage.createdOn,
      read: false
    });

    this.cdr.detectChanges()
  }

  /**
   * Open the notifications panel
   */
  openPanel(): void {
    // Return if the notifications panel or its origin is not defined
    if (!this._notificationsPanel || !this._notificationsOrigin) {
      return;
    }

    // Create the overlay if it doesn't exist
    if (!this._overlayRef) {
      this._createOverlay();
    }

    this.unreadCount = 0;

    // Attach the portal to the overlay
    this._overlayRef.attach(
      new TemplatePortal(this._notificationsPanel, this._viewContainerRef)
    );
  }

  /**
   * Close the notifications panel
   */
  closePanel(): void {
    this._overlayRef.detach();
  }

  /**
   * Create the overlay
   */
  private _createOverlay(): void {
    // Create the overlay
    this._overlayRef = this._overlay.create({
      hasBackdrop: true,
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy: this._overlay
        .position()
        .flexibleConnectedTo(
          this._notificationsOrigin._elementRef.nativeElement
        )
        .withLockedPosition(true)
        .withPush(true)
        .withPositions([
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
          },
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
          },
        ]),
    });

    // Detach the overlay from the portal on backdrop click
    this._overlayRef.backdropClick().subscribe(() => {
      this._overlayRef.detach();
    });
  }

  private _calculateUnreadCount(): void {
    let count = 0;

    // Per aggiornare il count con le sole notifiche non lette
    // if (this.messages && this.messages.length) {
    //     count = this.messages.filter(
    //         (message) => !message.read
    //     ).length;
    // }

    this.unreadCount = count;
  }
}
